var map = {
	"./assets/ajinomotoWheel/gameName.png": 8829,
	"./assets/bmiValentinesDayWheel/gameName.png": 2829,
	"./assets/christmasFortuneWheel/gameName.png": 6203,
	"./assets/classicWheel/gameName.png": 1046,
	"./assets/estivalWheel/gameName.png": 3268,
	"./assets/grippleWheel/gameName.png": 7315,
	"./assets/losteWheel/gameName.png": 754,
	"./assets/sirhaWheel/gameName.png": 2996,
	"./assets/stickAndPlayWheel/gameName.png": 8330
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9007;